/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  SummaryState,
  IntegratedSummary,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  TableColumnVisibility,
  ColumnChooser,
  TableSummaryRow,
} from '@devexpress/dx-react-grid-material-ui';
import { downloadCSVFile, getRowId } from '../../common';
import { getSalaryitems } from '../../graphql';
import { useLazyQuery } from '@apollo/client';
import {
  currencyFormatterEmpty,
  timeFormatter,
  userFormatter,
} from '../../Shared/colorFormat';
import { SearchTable } from '../../components';
import { getColumns } from '../../common/columns';
import { Box, IconButton, Typography } from '@material-ui/core';
import { useUsers } from '../../hooks';
import ExportBtn from '../../common/ExportBtn';
import { TableComponent } from '../components/TableComponent';
import HRContext from '../../contexts/hr';
import { getMonthName } from '../../constants/datatypes';
import _ from 'lodash';
import { moneyFormat } from '../common/formater';
import { SalaryPrint } from '../../print/SalaryPrint';
import { useReactToPrint } from 'react-to-print';
import MyIcon from '../components/MyIcon';
import { sleep } from '../../Shared/helpers';

export const updateDocTotal = ({ data, isRTL }: any) => {
  const rdata = data.map((d: any) => {
    const month = getMonthName({ num: d?.month, isRTL });
    const { basicSalary, extraSalary, bonos, overtime, deduction } = d;
    const total =
      (basicSalary || 0) +
      (extraSalary || 0) +
      (bonos || 0) +
      (overtime || 0) -
      (deduction || 0);
    return {
      ...d,
      month,
      total,
    };
  });
  return rdata;
};

const Salaryitems = forwardRef((props: any, ref: any) => {
  const {
    isRTL,
    words,
    start,
    end,
    currentViewNameChange,
    currentViewName,
    company,
    user,
  } = props;
  const col = getColumns({ isRTL, words });
  const [columns] = useState(
    [
      col.employee,
      { name: 'month', title: isRTL ? 'شهر' : 'Month' },
      { name: 'basicSalary', title: isRTL ? 'الراتب الاساسي' : 'Basic Salary' },
      { name: 'extraSalary', title: isRTL ? 'البدلات' : 'Allowances' },
      { name: 'overtime', title: isRTL ? 'اضافي' : 'Overtime' },
      { name: 'bonos', title: isRTL ? 'مكافئة' : 'Bonos' },
      { name: 'deduction', title: isRTL ? 'خصم' : 'Deduction' },
      { name: 'total', title: isRTL ? 'المجموع' : 'Total' },
      { name: 'isPaid', title: isRTL ? 'مدفوع' : 'Paid' },
      { name: 'paymentNo', title: isRTL ? 'مرجع الدفع' : 'Payment Ref' },
      { name: 'view', title: ' ' },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: col.employee.name, width: 250 },
    { columnName: 'month', width: 120 },
    { columnName: 'basicSalary', width: 150 },
    { columnName: 'extraSalary', width: 150 },
    { columnName: 'overtime', width: 120 },
    { columnName: 'bonos', width: 120 },
    { columnName: 'deduction', width: 120 },
    { columnName: 'total', width: 150 },
    { columnName: 'isPaid', width: 120 },
    { columnName: 'paymentNo', width: 120 },
    { columnName: 'view', width: 80, align: 'center' },
  ]);

  const [rows, setRows] = useState([]);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalLeft, setTotalLeft] = useState(0);
  const [selected, setSelected] = useState(null);
  const { users } = useUsers();

  const {
    state: { hiddenColumnNames },
    dispatch,
  } = useContext(HRContext);

  const setHiddenColumnNames = (hiddenColumns: any) => {
    dispatch({ type: 'setHiddenColumnNames', payload: hiddenColumns });
  };

  const [loadSalaryitems, opData]: any = useLazyQuery(getSalaryitems, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    loadSalaryitems({
      variables: {
        month: start ? new Date(start).getMonth() : new Date().getMonth(),
        year: start ? new Date(start).getFullYear() : new Date().getFullYear(),
      },
    });
  }, [start, end]);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  useEffect(() => {
    if (opData?.data?.getSalaryitems?.data) {
      const { data } = opData.data.getSalaryitems;
      const rdata = updateDocTotal({ data, isRTL });
      const tp = _.sumBy(
        rdata.filter((it: any) => it.isPaid),
        'total'
      );
      setTotalPaid(tp);
      const tnp = _.sumBy(
        rdata.filter((it: any) => !it.isPaid),
        'total'
      );
      setTotalLeft(tnp);
      setRows(rdata);
    }
  }, [opData]);
  useEffect(() => {
    if (currentViewName !== 'Month') {
      currentViewNameChange({ target: { value: 'Month' } });
    }
  }, [currentViewName]);

  const downloadCSVSubmit = () => {
    const colnames = columns?.map((col: any) => col?.name);
    downloadCSVFile(rows, 'Salary', colnames);
  };

  const totalSummaryItems = [
    { columnName: 'basicSalary', type: 'sum' },
    { columnName: 'extraSalary', type: 'sum' },
    { columnName: 'bonos', type: 'sum' },
    { columnName: 'overtime', type: 'sum' },
    { columnName: 'deduction', type: 'sum' },
    { columnName: 'total', type: 'sum' },
  ];

  const componentRef: any = useRef();
  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Salary`,
    removeAfterPrint: true,
  });

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          top: 8,
          left: isRTL ? 400 : undefined,
          right: isRTL ? undefined : 400,
          display: 'flex',
        }}
      >
        <ExportBtn open={downloadCSVSubmit} isRTL={isRTL}></ExportBtn>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <SummaryState totalItems={totalSummaryItems} />
        <IntegratedSummary />

        <SearchState />
        <IntegratedSorting />
        <IntegratedFiltering />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 40 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            col.employee.name,
            'month',
            'basicSalary',
            'extraSalary',
            'overtime',
            'bonos',
            'deduction',
            'total',
            'isPaid',
            'paymentNo',
            'view',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <TableColumnVisibility
          defaultHiddenColumnNames={hiddenColumnNames}
          hiddenColumnNames={hiddenColumnNames}
          onHiddenColumnNamesChange={setHiddenColumnNames}
        />
        <DataTypeProvider
          for={['time']}
          formatterComponent={timeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['isPaid']}
          formatterComponent={({ value }: any) => {
            return value ? (
              <span
                style={{
                  padding: 5,
                  color: '#25D366',
                  fontSize: 18,
                  fontWeight: 'bold',
                }}
              >
                ✔
              </span>
            ) : (
              <></>
            );
          }}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['view']}
          formatterComponent={({ row }: any) => {
            return (
              <IconButton
                style={{ height: 40 }}
                onClick={async () => {
                  setSelected(row);
                  await sleep(0.25);
                  handleReactPrint();
                }}
              >
                <MyIcon size={22} icon="print"></MyIcon>
              </IconButton>
            );
          }}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['userId']}
          formatterComponent={(props: any) =>
            userFormatter({ ...props, users })
          }
        ></DataTypeProvider>
        <DataTypeProvider
          for={[
            'overtime',
            'bonos',
            'deduction',
            'basicSalary',
            'extraSalary',
            'total',
          ]}
          formatterComponent={currencyFormatterEmpty}
        ></DataTypeProvider>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <ColumnChooser />
        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />
        <TableSummaryRow
          messages={{
            sum: isRTL ? 'المجموع' : 'Total',
          }}
        ></TableSummaryRow>
      </Grid>
      <Box
        style={{
          position: 'absolute',
          top: 70,
          left: 500,
          display: 'flex',
          minWidth: 400,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography style={{ fontWeight: 'bold' }}>
          {isRTL ? 'مجموع المدفوع' : 'Total Paid'} {moneyFormat(totalPaid)}
        </Typography>
        <Typography style={{ fontWeight: 'bold' }}>
          {isRTL ? 'مجموع المتبقي' : 'Total Remaining'} {moneyFormat(totalLeft)}
        </Typography>
      </Box>
      <div style={{ display: 'none' }}>
        <SalaryPrint
          company={company}
          user={user}
          printData={selected}
          isRTL={isRTL}
          ref={componentRef}
        />
      </div>
    </>
  );
});

export default Salaryitems;
